export enum AppReviewState{
    LIKE = "LIKE",
    DISLIKE = "DISLIKE"
}